import MockAdapter from 'axios-mock-adapter';
import { apiGoMock, apiNodeMock } from '@volta/redux/api';
import startMockManageUserServicesApi from './manage-user';
import startMockMasterApplicationsServicesApi from './master-applications';
import startMockBroadcastNotificationServicesApi from './broadcast-notification';
import startMockMotorcycleBundlesServicesApi from './motorcycle-bundle';
import startMockUpgradeVoltaPlusServicesApi from './upgrade-volta-plus';

var mock = new MockAdapter(apiNodeMock);
var mockGo = new MockAdapter(apiGoMock);

const startAllMockServicesApi = () => {
  startMockManageUserServicesApi();
  startMockMasterApplicationsServicesApi();
  startMockBroadcastNotificationServicesApi();
  startMockMotorcycleBundlesServicesApi();
  startMockUpgradeVoltaPlusServicesApi();
};

export { mock, mockGo };

export default startAllMockServicesApi;
